import { useMutation } from "react-query";
import paths from "../paths";
import axiosInstance from "../../Services/axiosConfig";

async function fetchCityData(state) {
  try {
    const url = paths.getCityList();
    const response = await axiosInstance.get(url, {
      params: {
        state,
        country: process.env.REACT_APP_COUNTRY,
        skip: 0,
        limit: 500,
      },
    });
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}

const useFetchCityData = () => {
  return useMutation(fetchCityData);
};

export { useFetchCityData };
